import type { BillingCycle } from '../../components/pricing/tiersData';

// SSOT no DB: public.plans.stripe_price_id (mig 20 — plans_and_gating.sql).
// Frontend precisa mandar price_id no body do create-checkout-session edge function
// (que espera Stripe price_id diretamente, não tier abstrato).
// Alinha com os 4 price IDs do seed em mig 20 (pro, pro_yearly, business, business_yearly).
export const STRIPE_PRICE_IDS: Record<'pro' | 'business', Record<BillingCycle, string>> = {
  pro: {
    monthly: 'price_1TNMnL37EZKNzUgEEp8BbSVQ',
    annual: 'price_1TNMnM37EZKNzUgEk1ZGsU5F',
  },
  business: {
    monthly: 'price_1TNMnN37EZKNzUgEpAWbIyjs',
    annual: 'price_1TNMnO37EZKNzUgERqLQniIK',
  },
} as const;
